import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { u as useIntl } from '../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { I as IconButton } from '../Button/IconButton/IconButton-ByrRWZ-V.js';
import { n as longArrowUp } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const SendButton = ({
  onClick,
  disabled,
  isActive = false
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    getDataTaktAttributes
  } = useTaktId({
    fallbackId: 'send-button'
  });
  const sendMessageLabel = formatMessage({
    id: 'action-send'
  });
  return /*#__PURE__*/React__default.createElement(IconButton, _extends({}, getDataTaktAttributes(), {
    variant: "primary",
    onClick: onClick,
    disabled: disabled || !isActive,
    icon: longArrowUp,
    label: sendMessageLabel,
    title: sendMessageLabel,
    small: true
  }));
};

export { SendButton as S };
//# sourceMappingURL=SendButton-BUl_DXnR.js.map
